import { Component, Input, OnInit } from '@angular/core';
import { RootScopeService } from 'src/app/services/root-scope.service';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {

  @Input() cardComponents: any[] =[];
  // { clientName: 'Premier Company Benefit Center', clientPhone: '1.847.295.5000', clientWebsite: 'http://resources.alight.com/premier', clientsData:'Client-specific, serice-specific greeting goes here.', clientsTerminology:'Lorem Ipsum' },
  // { clientName: 'Coco Company Benefit Center', clientPhone: '1.847.295.5001', clientWebsite: 'http://resources.alight.com/coco', clientsData:'Client-specific, greeting goes here.', clientsTerminology:'Lorem ipsum dolor sit amet' },
  // { clientName: 'Acho Company Benefit Center', clientPhone: '1.847.295.5002', clientWebsite: 'http://resources.alight.com/acho', clientsData:'Client-specific, serice-specific greeting goes here.', clientsTerminology:'Lorem ipsum dolor' },
  // { clientName: 'Wealth', clientPhone: '1.847.295.5003', clientWebsite: 'http://resources.alight.com/wealth', clientsData:'Client-specific, greeting goes here.', clientsTerminology:'Lorem ipsum dolor sit amet' },
  // { clientName: 'Target corporation', clientPhone: '1.847.295.5004', clientWebsite: 'http://resources.alight.com/target', clientsData:'Client-specific, serice-specific greeting goes here.', clientsTerminology:'Lorem ipsum dolor sit' },
  // { clientName: 'State farm Insurance', clientPhone: '1.847.295.5005', clientWebsite: 'http://resources.alight.com/sfi', clientsData:'Client-specific, serice-specific greeting goes here.', clientsTerminology:'Lorem Ipsum' },
  // ]; // Array of dynamic components to display
  slideWidth = 100; // Adjust as per your card width
  cardsToShow = 1; // Number of cards to show at a time
  currentCards: any[] = [];

  constructor(public rootScope: RootScopeService){ }

  ngOnInit() {
    this.updateCurrentCards();
  }

  next() {
    if (this.rootScope.clientInfoCard.clientInfoCardDefaultServiceIndex + this.cardsToShow < this.cardComponents.length) {
      this.rootScope.clientInfoCard.clientInfoCardDefaultServiceIndex += this.cardsToShow;
      this.updateCurrentCards();
    }
  }

  prev() {
    if (this.rootScope.clientInfoCard.clientInfoCardDefaultServiceIndex - this.cardsToShow >= 0) {
      this.rootScope.clientInfoCard.clientInfoCardDefaultServiceIndex -= this.cardsToShow;
      this.updateCurrentCards();
    }
  }

  selectItem(index: number) {
    this.rootScope.clientInfoCard.clientInfoCardDefaultServiceIndex = index;
    this.updateCurrentCards();
  }

  updateCurrentCards() {
    if( this.cardComponents &&  this.cardComponents.length > 0){
      return this.currentCards = this.cardComponents.slice(this.rootScope.clientInfoCard.clientInfoCardDefaultServiceIndex, this.rootScope.clientInfoCard.clientInfoCardDefaultServiceIndex + this.cardsToShow);
    }
    else{
      return [];
    }
  }
}